module.exports = __webpack_public_path__ + "img/PL08920.5f26a5cd.png";